define('lib/multivariate-testing/multivariate-testing',['require','exports','module','jquery','lib/multivariate-testing/test-configs/BaseTestConfig','mixpanel-helper'],function (require, exports, module) {
    var $ = require('jquery');
    var BaseTestConfig = require('lib/multivariate-testing/test-configs/BaseTestConfig');
    var mixpanelHelper = require('mixpanel-helper');

    var tests = [];

    function findTest(testId) {
        return tests.find(function (element) {
            return element.id === testId;
        });
    }

    module.exports = {
        /**
         * Store the provided test configs for later use.
         * Call this function at app start.
         *
         * @param {Object[]} initialTests - All test configs that will be used potentially.
         */
        initialize: function (initialTests) {
            var hasRequiredInterface = initialTests.every(function (testConfig) {
                return testConfig instanceof BaseTestConfig;
            });

            if (!hasRequiredInterface) {
                throw Error('At least one test is not an instance of the base test config.');
            }

            tests = initialTests;
        },

        /**
         * Allocates a user to a test variation, and saves that variation for later session.
         * Uses the allocation, check, and save strategies specified by the test config.
         *
         * @param {string} testId
         * @param {promise} Resolves when the variation is saved successfully.
         */
        saveVariation: function (testId) {
            var savingVariation;
            var test = findTest(testId);

            savingVariation = test.checkEligibility(testId).then(function () {
                return test.checkVariation(testId).then(function (existingVariation) {
                    if (existingVariation) {
                        return $.Deferred().reject('Test has already been saved with a variation.').promise();
                    }

                    return test.allocate(test.variations).then(function (variationId) {
                        var mixpanelObj = {};
                        mixpanelObj[testId + 'Test Variation'] = variationId;
                        window.mixpanel.register(mixpanelObj);
                        mixpanelHelper.track('Added to test: ' + testId);
                        return test.saveVariation(testId, variationId);
                    });
                });
            });

            test.savingVariation = savingVariation;

            return savingVariation;
        },

        /**
         * Checks to see the user already belongs to a variation for a specified test.
         * If a save action for a particular test is in progress, wait until that process completes before checking.
         *
         * @param {string} testId
         * @param {promise} Resolves with the variation, if one is set.
         */
        checkVariation: function (testId) {
            var test = findTest(testId);

            if (test.savingVariation) {
                var savingVariation = $.Deferred();

                // Continue with the check, even if save promise rejects.
                test.savingVariation.always(function () {
                    savingVariation.resolve();
                });

                return savingVariation.then(function () {
                    return test.checkVariation(testId);
                });
            }

            return test.checkVariation(testId);
        }
    };
});

